import { useQuery, useMutation } from '@tanstack/react-query';
import { getManagementSummary, downloadSummaryPdf, createShareLink } from '../value.api';

export function useManagementSummary(gln: string) {
  return useQuery({
    queryKey: ['value', 'management-summary', gln],
    queryFn: () => getManagementSummary(gln),
    enabled: !!gln,
    staleTime: 5 * 60 * 1000,
  });
}

export function useDownloadPdf(gln: string) {
  return useMutation({
    mutationFn: () => downloadSummaryPdf(gln),
    onSuccess: (blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'management-samenvatting.pdf';
      a.click();
      // Delay revoke to allow download to start
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    },
  });
}

export function useShareLink(gln: string) {
  return useMutation({
    mutationFn: () => createShareLink(gln),
  });
}
